<template>
  <div id="top">
    <div class="center">
      <h4 class="cyan-text text-darken-1">{{ name }}にようこそ！</h4>
      <p>{{ name }}(Feel Fill)は好きなネット配信番組を話したい人のためのチャットアプリです</p>
      <p><img class="coma" src="@/assets/coma1.png"></p>
      <p><img class="coma" src="@/assets/coma2.png"></p>
      <p><img class="coma" src="@/assets/coma3.png"></p>
      <p><img class="coma" src="@/assets/coma4.png"></p>


    </div>
  </div>
</template>

<script>
export default {
  name: 'Top',
  data(){
    return{
      name: 'フィルフィル'
    }
  }
}
</script>

<style>

h4{
margin-top: 50px;
}
.coma{
  with: 300px;
  height: 250px;
}

</style>



// WEBPACK FOOTER //
// src/components/home/Top.vue